var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBurgerArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.387 9.598a.657.657 0 0 1-.002.994l-4.358 3.76a1 1 0 0 1-1.306 0l-4.267-3.68a.762.762 0 1 1 .998-1.154l3.594 3.115a.5.5 0 0 0 .655 0l3.503-3.035a.9.9 0 0 1 1.183 0",
  clipRule: "evenodd"
})));
export default SvgBurgerArrow;